<template>
  <div>
    <van-dialog
      v-model="visible"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :class="{ dialog: true, page: page !== 1 ? true : false }"
      :style="{
        background: `url(${backgroundImage}) no-repeat`
      }"
    >
      <!-- <div style="height: 100%" v-for="item in component" :key="item.page"> -->
      <component
        @changePage="changePage"
        @removeClick="removeClick"
        @setPhone="setPhone"
        @setAreatype="setAreatype"
        @changeBackgroundImage="changeBackgroundImage"
        @getStatus="getStatus"
        :is="`page${page}`"
        :visible="visible"
        @showShowCheck="showShowCheck"
        @showPhoneHandel="showPhoneHandel"
        @scrollIntoView="scrollIntoView"
        :isActivity="isActivity"
      ></component>
      <!-- </div> -->
    </van-dialog>
  </div>
</template>

<script>
import page1 from './page1/index.vue'
import page2 from './page2/index.vue'
import page3 from './page3/index.vue'
import page4 from './page4/index.vue'
import page5 from './page5/index.vue'
export default {
  components: {
    page1,
    page2,
    page3,
    page4,
    page5
  },
  props: {
    visible: Boolean,
    page: Number,
    backgroundImage: String,
    isActivity: Boolean
  },
  data() {
    return {}
  },
  methods: {
    setPhone(phone) {
      this.$emit('setPhone', phone)
    },
    setAreatype(areatype) {
      this.$emit('setAreatype', areatype)
    },
    showShowCheck() {
      this.$emit('showShowCheck')
    },
    showPhoneHandel() {
      this.$emit('showPhoneHandel')
    },
    changeBackgroundImage(val) {
      this.$emit('changeBackgroundImage', val)
    },
    getStatus() {
      this.$emit('getStatus')
    },
    scrollIntoView(val) {
      this.$emit('scrollIntoView', val)
    },
    changePage(val) {
      this.$emit('changePage', val)
    },
    removeClick(val) {
      this.$emit('changeVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  height: 620px;
  width: calc(620px * 297 / 512);
  //   padding-right: 18px;
  //   margin-left: 10px;
  //   padding: 18px;
  background-size: 100% 100% !important;
  /deep/ .van-dialog__content {
    height: 100%;
  }
}
.page {
  margin-left: 0px;
  height: 320px;
  width: 320px;
  //   padding-right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/faceDialog/index.vue